module.exports = __webpack_public_path__ + "static/media/lastestupdate.0ef4307a.png";